<template>
  <div
    :class="
      `${
        vertical ? 'vertical w-full h-auto' : 'horizontal'
      } gap8 overflow-x-auto`
    "
  >
    <div class="btn-search-list" v-for="(item, index) in data" :key="index">
      <span :class="`${vertical ? 'w-full' : 'w-full col-elipsis'}`">
        {{ item[desc] }}
      </span>
      <i class="fa-solid fa-xmark cursor-pointer" @click="onClick(item.id)"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data', 'desc', 'onClick', 'vertical'],
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>
